export const POSADKY = [
  { nazev: "A", lide: ["Stanko", "?"] },
  { nazev: "B", lide: ["Děda", "Burka"] },
  { nazev: "C", lide: ["Novak", "Stanko"] },
];
